export default function ({route, redirect, store}) {
  const isAuthenticated = !!store.state.auth.user
  if (isAuthenticated) {
    redirect('/portal/actions/' + route.params.slug + '/' + route.params.code)
  }
}